import { FC, useMemo } from 'react'

import SafetyCaseFilterFormFields from './safety-case-filter-fields'

import { ISafetyCaseFilterFormProps } from './safety-case-filter-form-types'

const SafetyCaseFilterForm: FC<ISafetyCaseFilterFormProps> = props => {
  const { formName, handleSubmit, submitting, disabled, values } = props

  const isDisabled = useMemo(() => submitting || disabled, [submitting, disabled])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseFilterFormFields disabled={isDisabled} values={values} />
    </form>
  )
}

export default SafetyCaseFilterForm
